import { TrackingService } from '@app/core/services/tracking/tracking.service';
import { RegisterUser } from '@app/core/models';
import { Component, OnInit, inject } from '@angular/core';
import {
  Validators,
  FormsModule,
  ReactiveFormsModule,
  FormGroup,
  FormControl,
  FormBuilder,
} from '@angular/forms';
import { RegisterService } from '@app/core/services';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { EMPTY } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { RCFieldModule, RCButtonModule } from '@rc/ui';
import { TrackingDirective } from '@app/core/services/tracking/tracking.directive';
import { LoaderComponent } from '@app/shared/components/loader/loader.component';
import { ContactUsButtonComponent } from '@app/shared/components/contact-us/contact-us-button/contact-us-button.component';
import { LogoComponent } from '@app/shared/components/logo/logo.component';

/**
 * Here's the expected data structure
 * `history.state.data = {
 *       callback: 'https://account.royalcanin.com',
 *       locale: 'fr_FR',
 *       profile: {
 *         firstName: 'Stéphane',
 *         lastName: 'Francel',
 *         email: 'sfrancel@yopmail.com',
 *         login: 'sfrancel@yopmail.com',
 *         locale: 'fr_FR',
 *         preferredLanguage: 'fr-FR',
 *         countryCode: 'FR'
 *       },
 *       credentials: {
 *         password: {
 *           value: '2020@Pazword'
 *         }
 *       }
 *     };`
 */
@Component({
  selector: 'app-register-page-success',
  templateUrl: './register-page-primary-phone-success.component.html',
  styleUrls: ['./register-page-primary-phone-success.component.scss'],
  imports: [
    LoaderComponent,
    TrackingDirective,
    FormsModule,
    ReactiveFormsModule,
    RCFieldModule,
    RCButtonModule,
    TranslateModule,
    ContactUsButtonComponent,
    LogoComponent,
  ],
})
export class RegisterPagePrimaryPhoneSuccessComponent implements OnInit {
  private readonly formBuilder = inject(FormBuilder);
  private registerService = inject(RegisterService);
  private translateService = inject(TranslateService);
  private trackingService = inject(TrackingService);

  user!: RegisterUser;
  redirectUri?: string;
  registerSuccessForm!: FormGroup<{ code: FormControl<string | null> }>;
  codeVerified = false;
  loginRedirect!: string;
  error?: string;
  user_id!: string;
  submitted = false;

  ngOnInit(): void {
    this.buildRegisterSuccessForm();
    this.user = history.state.data;
    this.user_id = history.state.user_id;
    this.loginRedirect = this.redirectUri || `${origin}/implicit/login`;
    this.sendVerificationCode();
  }

  buildRegisterSuccessForm(): void {
    this.registerSuccessForm = this.formBuilder.group({
      code: this.formBuilder.control<string | null>(null, [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(6),
      ]),
    });
  }
  onSubmit(): void {
    this.submitted = true;
    const activationPhoneBody = {
      locale: this.user.locale,
      passcode: this.registerSuccessForm.controls.code.value!,
      login: this.user.profile.login,
      callback: this.user.callback,
    };
    this.registerService
      .activatePhoneUser(activationPhoneBody)
      .pipe(
        tap((resp) => {
          this.codeVerified = true;
          window.setTimeout(() => {
            window.location.href = resp.activation_link;
          }, 3000);
        }),
        catchError(() => {
          this.submitted = false;
          this.trackingService.pushEvent('registration.passcodeCheckError');
          this.error = this.translateService.instant(
            'PhoneValidation_OTCCodeError',
          );
          return EMPTY;
        }),
      )
      .subscribe();
  }
  sendVerificationCode(): void {
    this.registerService
      .sendNewPhoneCode(this.user_id)
      .pipe(
        tap(() => {
          this.registerSuccessForm.reset();
          this.registerSuccessForm.enable();
          this.submitted = false;
        }),
        catchError(() => {
          this.error = this.translateService.instant(
            'PhoneValidation_OTCCodeError',
          );
          return EMPTY;
        }),
      )
      .subscribe();
  }
  goToLogin(): void {
    window.location.href = this.loginRedirect;
  }
}
